import RelevantArticles from './relevant-articles'

export default RelevantArticles
